import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectizeComponent, ModalService } from '../../blocks';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-infection-control-tracking',
  templateUrl: './infection-control-tracking.component.html',
  styleUrls: ['./infection-control-tracking.component.css']
})
export class InfectionControlTrackingComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  categorySerial: number;
  subCategorySerial: number;
  @ViewChild('categorySelectize') categorySelectize: SelectizeComponent;
  @ViewChild('subCategorySelectize') subCategorySelectize: SelectizeComponent;
  @ViewChild('interventionsSelectize') interventionsSelectize: SelectizeComponent;
  constructor(private _modalService: ModalService, public translate: TranslateService) { }
  ngOnInit() {
  }
  categoryClicked() {
    this.subCategorySelectize.clear();
    this.subCategorySelectize.clearItems();
    this.interventionsSelectize.clear();
    this.interventionsSelectize.clearItems();
  }
  subCategoryClicked() {
    this.interventionsSelectize.clear();
    this.interventionsSelectize.clearItems();
  }
  plans = [
    {
      name: 'Hand Hygiene Plan',
      description: 'A plan to improve hand hygiene across the facility.',
      selectedInterventions: [
        { name: 'Ensure staff wash hands for at least 20 seconds.', completed: false },
        { name: 'Focus on cleaning fingertips, nails, and between fingers.', completed: false }
      ],
      responsiblePerson: 'John Doe',
      timeline: new Date(),
      progress: 0
    },
    // Add more plans as needed
  ];

  selectedPlan: any = null;
  // Load plan details when a plan is selected
  loadPlanDetails() {
    this.calculateProgress();
  }

  // Update progress based on completed interventions
  updateProgress() {
    const completedInterventions = this.selectedPlan.selectedInterventions.filter(intervention => intervention.completed).length;
    this.selectedPlan.progress = (completedInterventions / this.selectedPlan.selectedInterventions.length) * 100;
  }

  // Calculate initial progress when the plan is loaded
  calculateProgress() {
    if (this.selectedPlan) {
      this.updateProgress();
    }
  }

  // Handle form submission
  onSubmit() {
    const formData = {
      planName: this.selectedPlan.name,
      description: this.selectedPlan.description,
      responsiblePerson: this.selectedPlan.responsiblePerson,
      timeline: this.selectedPlan.timeline,
      progress: this.selectedPlan.progress,
      interventions: this.selectedPlan.selectedInterventions.map(intervention => ({
        name: intervention.name,
        completed: intervention.completed
      }))
    };

    console.log('Form Data:', formData);

   
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
